<template>
  <slide1 />
  <transition name="gradient1">
    <div class="gradient" v-if="windows.main.slide === 1">
      <div
          style="
        z-index: -10;
        position: absolute;
        width: 682.96px;
        height: 682.96px;
        left: -476px;
        top: 380px;
        background: radial-gradient(50% 50% at 50% 50%,rgba(0, 133, 255, 0.2) 0%,rgba(0, 133, 255, 0) 100%);
      "
      ></div>
      <div
          style="
        z-index: -10;
        position: absolute;
        width: 682.96px;
        height: 682.96px;
        left: -356.7px;
        top: 552.87px;
        background: radial-gradient(50% 50% at 50% 50%,rgba(242, 41, 89, 0.3) 0%,rgba(242, 41, 89, 0) 100%);
      "
      ></div>
      <div
          style="
        z-index: -10;
        position: absolute;
        width: 682.96px;
        height: 682.96px;
        left: -99.22px;
        top: 789.04px;
        background: radial-gradient(50% 50% at 50% 50%,rgba(0, 133, 255, 0.2) 0%,rgba(0, 128, 247, 0) 100%);
      "
      ></div>
    </div>
  </transition>
  <slide2 />
  <div
    class="gradient"
    id="grad-3-4"
    :style="windows.main.slide === 2 ? 'top: calc(100vh + 524px)' : 'top: calc(200vh - 346px)' "
    style="
      z-index: -10;
      transition: all linear 0.8s;
      position: absolute;
      width: 1122px;
      height: 1122px;
      left: 254px;

      background: radial-gradient(50% 50% at 50% 50%, rgba(255, 46, 83, 0.2) 0%, rgba(255, 46, 83, 0) 100%);
    "
  ></div>
  <slide3 />
  <slide4
      :clientSlide="windows.main.slide3.clientSlide"
  />
  <slide5  />
  <div
    class="gradient blue-grad-5"
    :class="windows.main.slide > 5 ? 'unactive' : ''"
    style="
      z-index: -10;
      position: absolute;
      width: 1122px;
      height: 1122px;
      top: calc(400vh + 190px);
      background: radial-gradient(50% 50% at 50% 50%,rgba(0, 133, 255, 0.2) 0%,rgba(0, 133, 255, 0) 100%);
    "
  ></div>
  <slide6 />
  <transition name="gradient">
    <div
        v-if="windows.main.slide === 6"
        class="gradient"
        style="
        z-index: -10;
        position: absolute;
        width: 1122px;
        height: 1122px;
        left: 374px;
        top: calc(500vh + 335px);
        background: radial-gradient(50% 50% at 50% 50%, rgba(255, 46, 83, 0.2) 0%, rgba(255, 46, 83, 0) 100%);
      "
    ></div>
  </transition>

  <slide7/>
  <transition name="gradient">
    <div
        class="gradient last-gradient"
        :class="'slide-' + windows.main.slide"
        style="
        z-index: -10;
        position: absolute;
        width: 1122px;
        height: 1122px;
        left: -561px;

        background: radial-gradient(50% 50% at 50% 50%, rgba(0, 133, 255, 0.2) 0%, rgba(0, 133, 255, 0) 100%);
      "
    ></div>
  </transition>
  <slide8 />
</template>

<script>
import slide1 from "@/components/tablet/main/slide1";
import slide2 from "@/components/tablet/main/slide2";
import slide3 from "@/components/tablet/main/slide3";
import slide4 from "@/components/tablet/main/slide4";
import slide5 from "@/components/tablet/main/slide5";
import slide6 from "@/components/tablet/main/slide6";
import slide7 from "@/components/tablet/main/slide7";
import slide8 from "@/components/tablet/main/slide8";

export default {
  name: "Main",
  props: ["windows"],
  components: {
    slide1,
    slide2,
    slide3,
    slide4,
    slide5,
    slide6,
    slide7,
    slide8,
  },
};
</script>

<style lang="scss" scoped>
/* we will explain what these classes do next! */
.gradient1-enter-active,
.gradient1-leave-active {
  transition: opacity 0.8s linear;
}

.gradient1-enter-from,
.gradient1-leave-to {
  opacity: 0;
}

.last-gradient{
  transition: all linear .8s;
  &.slide-7{
    top: calc(600vh + 650px);
  }
  &.slide-8{
    top: calc(700vh - 150px);
  }
}
</style>
